import errorMessages from "utils/validation/errorMessages";
import { dateOptionalSchema, emailSchema, endnDateOptionalSchema, phoneRequiredSchema, select2RequiredSchema, statusSchema, stringRequiredSchema, urlOptionalSchema } from "utils/validation/validationHelpers";
import { array, object, number, string } from 'yup';

const addPrivateClientSchema = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    dob: stringRequiredSchema,
    gender: select2RequiredSchema,
    // service_status: select2RequiredSchema,
    city_town: stringRequiredSchema,
    report_url: string().optional().url(errorMessages.url),
    parents: array().of(object().shape({
        firstname: stringRequiredSchema,
        lastname: select2RequiredSchema,
        phone: phoneRequiredSchema,
        email: emailSchema,
        id: number().nullable().optional()
    })),
    status: statusSchema,
    start_date: dateOptionalSchema,
    end_date: endnDateOptionalSchema,
    is_confirmed: stringRequiredSchema,
    funding_source: select2RequiredSchema,
    documents: array().of(object().shape({
        attachment_key: stringRequiredSchema,
        attachment_name: stringRequiredSchema
    })),
});

export default addPrivateClientSchema;